<template>
    <button class="login-m-btn" @click="handleMetamaskLogin">
        <MetamaskLogo />
        <span>Metamask</span>
    </button>
</template>

<script>
import Web3 from 'web3';
import MetamaskLogo from '@/decast/icons/MetamaskLogo.vue';

export default {
    name: "MetamaskLogin",
    components: {
        MetamaskLogo,
    },
    data() {
        return {
            //wallet data
            publicAddress: '',
            signature: '',
            nonce: '',
            coinbase: '',
            isRequestingAccounts: false,
        };
    },
    methods: {
        async handleMetamaskLogin() {
            if (this.isRequestingAccounts) return;

            this.isRequestingAccounts = true;
            this.publicAddress = '';
            this.signature = '';
            this.nonce = '';
            this.coinbase = '';

            document.getElementById('loading-bg-transparent-title').innerText = '🔗 Connecting to MetaMask';
            document.getElementById('loading-bg-transparent').style.display = 'flex';

            try {
                const web3 = new Web3(Web3.givenProvider);
                if (!web3.givenProvider) {
                    this.$vs.notify({
                        title: this.$t('Login.notify.title'),
                        text: this.$t('Metamasklogin.install'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                    this.isRequestingAccounts = false;
                    return;
                }

                // const accounts = await window.ethereum.request({
                //     method: 'eth_requestAccounts',
                // });
                const accounts = await this.withTimeout(
                    window.ethereum.request({ method: 'eth_requestAccounts' }),
                    15000
                );

                const account = accounts[0];
                const coinbase = await web3.eth.getCoinbase();

                if (!coinbase) {
                    this.$vs.notify({
                        title: this.$t('Login.notify.title'),
                        text: this.$t('Metamasklogin.activate'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                    this.isRequestingAccounts = false;
                    return;
                }

                this.publicAddress = account.toLowerCase();
                this.$store
                    .dispatch('auth/v2getNonce', { address: this.publicAddress })
                    .then((res) => {
                        this.handleSignMessage(this.publicAddress, res.data.nonce, res.data.token);
                    })
                    .catch(() => {
                        this.$vs.notify({
                            title: this.$t('Login.notify.title'),
                            text: this.$t('Metamasklogin.tryagain'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    });
            } catch (error) {
                if (error.code === -32002) {
                    this.$vs.notify({
                        title: this.$t('Login.notify.title'),
                        text: 'MetaMask is already processing a request. Please check the extension.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                } else if (error.message === 'MetaMask timeout') {
                    this.$vs.notify({
                        title: this.$t('Login.notify.title'),
                        text: '⏱️ No response from MetaMask. You may have closed the popup.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning',
                    });
                } else {
                    console.error('MetaMask Login Error:', error);
                }
            } finally {
                this.isRequestingAccounts = false;
                document.getElementById('loading-bg-transparent').style.display = 'none';
            }
        },

        // async handleMetamaskLogin() {
        //     this.publicAddress = '';
        //     this.signature = '';
        //     this.nonce = '';
        //     this.coinbase = '';
        //     const web3 = new Web3(Web3.givenProvider);
        //     if (!web3.givenProvider) {
        //         this.$vs.notify({
        //             title: this.$t('Login.notify.title'),
        //             text: this.$t('Metamasklogin.install'),
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'warning',
        //         });
        //     }
        //     const accounts = await window.ethereum.request({
        //         method: 'eth_requestAccounts',
        //     });
        //     const account = accounts[0];
        //     const coinbase = await web3.eth.getCoinbase();
        //     if (!coinbase) {
        //         this.$vs.notify({
        //             title: this.$t('Login.notify.title'),
        //             text: this.$t('Metamasklogin.activate'),
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'warning',
        //         });
        //     }
        //     this.publicAddress = account.toLowerCase();
        //     this.$store
        //         .dispatch('auth/v2getNonce', { address: this.publicAddress })
        //         .then((res) => {
        //             // Popup MetaMask confirmation to sign message
        //             this.handleSignMessage(this.publicAddress, res.data.nonce, res.data.token)
        //         })
        //         .catch((err) => {
        //             this.$vs.notify({
        //                 title: this.$t('Login.notify.title'),
        //                 text: this.$t('Metamasklogin.tryagain'),
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger',
        //             });
        //         });
        // },

        async handleSignMessage(publicAddress, nonce, token) {
            // Loading
            document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻 Signing to metamask';
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            try {
                const web3 = new Web3(Web3.givenProvider);
                const signature = await web3.eth.personal.sign(
                    nonce,
                    publicAddress,
                    '' // MetaMask will ignore the password argument here
                );
                this.signature = signature;
                this.nonce = nonce;
                // Send signature to backend for auth...
                this.$store
                    .dispatch('auth/v2sendSignature', {
                        token: token,
                        signature: this.signature,
                    })
                    .then((response) => {
                        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
                        if (isTwoFactorAuthEnabled) {
                            //ask for 2fa
                            const twoFactorToken = response.data?.token;
                            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
                        } else {
                            this.$store.commit('auth/SET_LOGGEDIN', true);
                            this.$acl.change('user');
                            this.$vs.notify({
                                title: this.$t('Login.notify.title'),
                                text: 'Login Successfull',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success',
                            });
                            this.$router.push('/dashboard/rooms');
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: this.$t('Login.notify.title'),
                            text: this.$t('Metamasklogin.tryagain'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    }).finally(() => {
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    });
            } catch (err) {
                this.$vs.notify({
                    title: this.$t('Login.notify.title'),
                    text: this.$t('Metamasklogin.signmessage'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
            } finally {
                document.getElementById('loading-bg-transparent').style.display = 'none';
            }
        },

        withTimeout(promise, timeout = 15000) {
            return Promise.race([
                promise,
                new Promise((_, reject) => setTimeout(() => reject(new Error('MetaMask timeout')), timeout))
            ]);
        },
    },
};
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

.login-m-btn {
  height: 78px;
  width: 80px;
  background-color: #15161F !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #FFFFFF;
  font-size: 10px;
  padding: 12px 20px;
  pointer-events: auto;
}

.login-m-btn svg {
  height: 30px !important;
  width: 30px !important;
  margin-bottom: 10px;
}
</style>